import React, { useEffect, useState } from 'react'

import { func } from 'prop-types'

let ThreeDModelPicker = null
let threeDModelPickerImportPromise = null

export const importThreeDModelPicker = () => {
  if (!threeDModelPickerImportPromise) {
    threeDModelPickerImportPromise = import(
      /* webpackChunkName: "three-d-model-picker" */
      'Pods/LazyLoaded/ThreeDModelPicker/ThreeDModelPicker'
    ).then((mod) => { ThreeDModelPicker = mod.default })
  }
  return threeDModelPickerImportPromise
}

function LazyThreeDModelPicker({ onClose }) {
  const [isLoaded, setIsLoaded] = useState(() => !!ThreeDModelPicker)

  useEffect(() => {
    if (!ThreeDModelPicker) {
      importThreeDModelPicker().then(() => setIsLoaded(true))
    }
  }, [])

  if (!isLoaded || !ThreeDModelPicker) return null
  return <ThreeDModelPicker onClose={onClose} />
}

LazyThreeDModelPicker.propTypes = {
  onClose: func.isRequired,
}

export default LazyThreeDModelPicker
